import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import { checkPermissionStatus } from "helpers/utils";
import { getAllSkills, getRoundsData } from "services/commonService";
import { ReactSortable } from "react-sortablejs";
import { faUpDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { isEmpty } from "lodash";
import { getUserInfo } from "helpers/authHelper";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";

const styles = {
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? "#E27235" : "",
  }),
};

const animatedComponents = makeAnimated();

const EditJob = props => {
  const history = useHistory();
  let { jobId } = useParams();
  const [errors, setErrors] = useState({});
  const [vtypes, setVType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statePayload, setStatePayload] = useState({
    status: "1",
    location_mapped_with: "city",
  });
  const [City, setCity] = useState([]);
  const [allCityLocations, setAllCityLocations] = useState([]);
  const [FranchiseList, setFranchiseList] = useState([]);
  const [allFranchiseLocations, setAllFranchiseLocations] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const companyCurrency = getUserInfo()?.company_currency || {};
  const [allSkills, setAllSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const handleInput = event => {
    const { name, value } = event.target;
    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleVtypeSelection = vacancyID => {
    setStatePayload(prevState => ({
      ...prevState,
      vacancy_type_id: vacancyID,
    }));
  };

  const updateJob = async payload => {
    await api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/Job/update-job/${jobId}`,
        payload
      )
      .then(response => {
        setIsLoading(false);
        toast.success("Job Updated successfully");
        history.push("/Job-list");
      })
      .catch(err => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const [selectedModeOfJob, setSelectedModeOfJob] = useState(null);
  const handleSelectMode = selectedModeOfJob => {
    setSelectedModeOfJob(selectedModeOfJob);
    setStatePayload(prevState => ({
      ...prevState,
      mode_of_job: selectedModeOfJob?.value,
    }));
  };

  const [selectedNumberOfJobsOption, setSelectedNumberOfJobOptions] =
    useState(null);
  const handleNumberOfJobs = selectedNumberOfJobsOption => {
    setSelectedNumberOfJobOptions(selectedNumberOfJobsOption);
    setStatePayload(prevState => ({
      ...prevState,
      number_of_jobs: selectedNumberOfJobsOption?.value,
    }));
  };

  const [selectedCities, setSelectedCities] = useState([]);
  const handleSelectAllCities = () => {
    setSelectedCities(City);
    const allCityValues = City.map(city => city.id);
    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
    }));
  };

  const handleDeselectAllCities = () => {
    setSelectedCities([]);
    setSelectedCityLocations([]);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: [],
      location_id: [],
    }));
  };

  const handleChangeCity = selectedCities => {
    if (!selectedCities?.length) {
      handleDeselectAllCities();

      return;
    }

    setSelectedCities(selectedCities);
    const allCityValues = selectedCities?.map(city => city.id);

    let tempLocations = selectedCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.city)
    );
    setSelectedCityLocations(tempLocations);
    let allLocationValues = tempLocations?.map(location => location?.id);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
      location_id: allLocationValues,
    }));
  };

  const [selectedCityLocations, setSelectedCityLocations] = useState([]);
  const handleSelectAllCityLocations = () => {
    if (!selectedCities?.length) {
      handleDeselectAllCityLocations();

      return;
    }

    let tempLocations = allCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.label)
    );

    setSelectedCityLocations(
      tempLocations?.reduce(
        (prev, curr) => [...prev, ...(curr?.options || [])],
        []
      )
    );
    let allLocationValues = tempLocations?.reduce(
      (prev, curr) => [...prev, ...curr?.options?.map(c => c?.id)],
      []
    );
    setStatePayload(prevState => ({
      ...prevState,
      location_id: allLocationValues,
    }));
  };

  const handleDeselectAllCityLocations = () => {
    setSelectedCityLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      location_id: [],
    }));
  };

  const handleChangeCityLocation = options => {
    setSelectedCityLocations(options);
    let locationValues = options?.map(location => location?.id);
    setStatePayload(prevState => ({
      ...prevState,
      location_id: locationValues,
    }));
  };

  const [selectedFranchiseLocations, setSelectedFranchiseLocations] = useState(
    []
  );
  const handleSelectAllFranchiseLocations = () => {
    if (!statePayload?.franchise_id) {
      handleDeselectAllFranchiseLocations();

      return;
    }

    setSelectedFranchiseLocations(allFranchiseLocations);
    let allLocationValues = allFranchiseLocations?.map(loc => loc?.id);

    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: allLocationValues,
    }));
  };

  const handleDeselectAllFranchiseLocations = () => {
    setSelectedFranchiseLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: [],
    }));
  };

  const handleChangeFranchiseLocation = options => {
    setSelectedFranchiseLocations(options);

    let locationValues = options?.map(location => location?.id);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: locationValues,
    }));
  };

  const [selectedDepts, setSelectedDepts] = useState([]);

  const handleSelectAllDepts = () => {
    setSelectedDepts(allDepartments);

    let allDeptValues = allDepartments?.map(dept => dept?.id);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const handleDeselectAllDepts = () => {
    setSelectedDepts([]);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: [],
    }));
  };

  const handleChangeDept = (options = []) => {
    setSelectedDepts(options || []);

    let allDeptValues = options?.map(dept => dept?.id) || [];

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const fetchRoundsData = async () => {
    await getRoundsData()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setRoundList(responseData?.data);
        } else {
          toast.error("No data available");
          setRoundList([]);
        }
      })
      .catch(err => {
        toast.error("No data Available");
        setRoundList([]);
      });
  };

  // Appending buttons to the options list
  const extendedCityOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button className="selectall-btn" onClick={handleSelectAllCities}>
            Select All
          </button>
          <button className="selectall-btn" onClick={handleDeselectAllCities}>
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...City,
  ];

  const extendedCityLocationOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button
            className="selectall-btn"
            onClick={handleSelectAllCityLocations}
          >
            Select All
          </button>
          <button
            className="selectall-btn"
            onClick={handleDeselectAllCityLocations}
          >
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.label)
    ),
  ];

  const extendedFranchiseLocationOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button
            className="selectall-btn"
            onClick={handleSelectAllFranchiseLocations}
          >
            Select All
          </button>
          <button
            className="selectall-btn"
            onClick={handleDeselectAllFranchiseLocations}
          >
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allFranchiseLocations,
  ];

  const extendedDeptOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button className="selectall-btn" onClick={handleSelectAllDepts}>
            Select All
          </button>
          <button className="selectall-btn" onClick={handleDeselectAllDepts}>
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allDepartments,
  ];

  const expectedTimeOptions = [
    { label: "Part-Time", value: "Part-Time" },
    { label: "Full-Time", value: "Full-Time" },
    { label: "Contract", value: "Contract" },
    { label: "Freelance", value: "Freelance" },
    { label: "Temporary", value: "Temporary" },
  ];

  const extendedOptions1 = [
    {
      value: "Onsite",
      label: "Onsite",
    },
    {
      value: "Hybrid",
      label: "Hybrid",
    },
    {
      value: "Remote",
      label: "Remote",
    },
  ];
  const extendedOptions2 = [
    {
      value: "Limited",
      label: "Limited",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
  ];

  const handleSubmit = async event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    if (statePayload?.vacancy_type_id === "") {
      errorObj = {
        ...errorObj,
        vacancy_type_id: "Position Level is Required!",
      };
    }
    if (
      ["franchise"].includes(statePayload?.location_mapped_with?.toLowerCase())
    ) {
      if (!statePayload?.franchise_id) {
        errorObj = {
          ...errorObj,
          franchise_id: "Franchise is Required!",
        };
      }
    } else {
      if (isEmpty(statePayload?.city_id)) {
        errorObj = {
          ...errorObj,
          city_id: "City is Required!",
        };
      }
    }
    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }
    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (isEmpty(statePayload?.experience)) {
      errorObj = {
        ...errorObj,
        experience: "Experience is Required!",
      };
    }
    if (statePayload?.status === "") {
      errorObj = {
        ...errorObj,
        status: "Status is Required!",
      };
    }
    if (statePayload?.mode_of_job === "") {
      errorObj = {
        ...errorObj,
        mode_of_job: "Mode of Job is Required!",
      };
    }
    if (statePayload?.number_of_jobs === "") {
      errorObj = {
        ...errorObj,
        number_of_jobs: "Number of Vacancies is Required!",
      };
    }
    if (isEmpty(statePayload?.description)) {
      errorObj = {
        ...errorObj,
        description: "Job Description is Required!",
      };
    }
    if (isEmpty(selectedSkills)) {
      errorObj = {
        ...errorObj,
        skills: "Skills are Required!",
      };
    }
    if (isEmpty(statePayload?.expected_time)) {
      errorObj = {
        ...errorObj,
        expected_time: "Expected Time is Required!",
      };
    }
    if (isEmpty(statePayload?.min_salary)) {
      errorObj = {
        ...errorObj,
        min_salary: "This Field is Required!",
      };
    }
    if (isEmpty(statePayload?.max_salary)) {
      errorObj = {
        ...errorObj,
        max_salary: "This Field is Required!",
      };
    }
    if (statePayload?.relevance_score === "") {
      errorObj = {
        ...errorObj,
        relevance_score: "This Field is Required!",
      };
    }
    if (statePayload?.video_analysis_score === "") {
      errorObj = {
        ...errorObj,
        video_analysis_score: "This Field is Required!",
      };
    }
    if (isEmpty(statePayload?.video_analysis_ques)) {
      errorObj = {
        ...errorObj,
        video_analysis_ques: "This Field is Required!",
      };
    }

    // Setting the error object if any errors are present;
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      setIsLoading(false);
      return false;
    }

    let skillIds =
      selectedSkills?.filter(skill => !!skill?.id)?.map(skill => skill?.id) ||
      [];
    let createdSkills =
      selectedSkills?.filter(skill => !skill?.id)?.map(skill => skill?.label) ||
      [];

    let company_id;

    if (statePayload?.company_id == undefined) {
      company_id = localStorage.getItem("subdomainId");
    } else {
      company_id = statePayload?.company_id;
    }

    let payload = {
      title: statePayload?.title,
      description: statePayload?.description,
      qualification: statePayload?.qualification,
      skillIds: JSON.stringify(skillIds),
      createdSkills: JSON.stringify(createdSkills),
      experience: statePayload?.experience,
      vacancy_type_id: statePayload?.vacancy_type_id,
      expected_time: statePayload?.expected_time,
      status: statePayload?.status,
      location_mapped_with: statePayload?.location_mapped_with || "city",
      city_id: statePayload?.city_id?.join(","),
      location_id: selectedCityLocations?.map(location => ({
        location_id: location?.id,
        country_id: location?.country_id,
        region_id: location?.region_id,
        state_id: location?.state_id,
        city_id: location?.city_id,
      })),
      franchise_id: statePayload?.franchise_id,
      franchise_location_id: selectedFranchiseLocations?.map(loc => ({
        location_id: loc?.id,
        country_id: loc?.country_id,
        region_id: loc?.region_id,
        state_id: loc?.state_id,
        city_id: loc?.city_id,
      })),
      department_id: selectedDepts?.map(dept => dept?.id),
      mode_of_job: statePayload?.mode_of_job,
      number_of_jobs: statePayload?.number_of_jobs,
      number_of_openings: statePayload?.number_of_openings,
      min_salary: parseInt(statePayload?.min_salary),
      max_salary: parseInt(statePayload?.max_salary),
      relevance_score: statePayload?.relevance_score,
      video_analysis_score: statePayload?.video_analysis_score,
      video_analysis_ques: statePayload?.video_analysis_ques,
      company_id: company_id,
    };

    payload = encryptDataToArray(payload);

    await updateJob({
      query: payload,
    });
  };

  const fetchJobDetails = async () => {
    // console.log('user',userId);
    await api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/Job/fetch-jobbyid/${jobId}`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        const { success, allJobs } = responseData || {};
        if (success) {
          setStatePayload({
            ...allJobs,
            location_mapped_with: allJobs?.location_mapped_with || "city",
            min_salary: allJobs?.min_salary?.toString(),
            max_salary: allJobs?.max_salary?.toString(),
          });
          let round_list = allJobs?.roundList || [];
          setRoundList(round_list);

          setSelectedCities(allJobs?.cityList || []);
          setSelectedCityLocations(allJobs?.locationList || []);
          setSelectedDepts(allJobs?.vacancyDepartments || []);

          let vacancy_skills = (allJobs?.vacancySkills || [])?.map(skill => ({
            value: skill?.id,
            label: skill?.name,
            ...skill,
          }));
          setSelectedSkills(vacancy_skills);
        }
      })
      .catch(err => {});
  };

  const fetchVacancyTypeData = () => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/fetch-vacancytype`
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        const { success, allVacType } = responseData || {};

        if (success) {
          let data = allVacType?.map(item => ({
            id: item?.id,
            label: item?.title,
            value: item?.vacancy_name,
          }));
          setVType(data);
        }
      })
      .catch(err => {});
  };

  const fetchCityData = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/city-listing?language_id=${language}`,
      )
      .then(response => {
        const allCity = response.data.cities;
        let data = allCity?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.city,
        }));
        setCity(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const fetchAllCityLocations = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/location-listing?language_id=${language}`
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let allCityLocations = responseData?.allLocations || [];
        let groupedData = allCityLocations?.reduce((prev, curr) => {
          let currCity = curr?.city;
          let currCityOptions = prev?.[currCity]?.options || [];
          currCityOptions.push(curr);
          prev[currCity] = {
            label: currCity,
            options: currCityOptions,
          };

          return prev;
        }, {});
        groupedData = Object.values(groupedData);

        setAllCityLocations(groupedData);
      })
      .catch(err => {});
  };

  const fetchAllFranchiseWithLocations = () => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/Franchise/list-with-location`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let FranchiseList = responseData?.data || [];

        setFranchiseList(FranchiseList);
        setAllFranchiseLocations([]);
      })
      .catch(err => {});
  };

  const fetchAllDepartments = () => {
    let language = localStorage.getItem("lang_id") || 1;
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/job/all-departments?language_id=${language}`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);
        let allDepartments = responseData?.data?.allDepartments || [];

        setAllDepartments(allDepartments);
      })
      .catch(err => {
        setAllDepartments([]);
      });
  };

  const fetchAllSkills = async () => {
    await getAllSkills()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        let allSkills = responseData?.data?.companySkills || [];
        allSkills = allSkills?.map(skill => ({
          value: skill?.id,
          label: skill?.name,
          ...skill,
        }));
        setAllSkills(allSkills);
      })
      .catch(err => {
        toast.error("No skills Available");
        setAllSkills([]);
      });
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  useEffect(() => {
    fetchJobDetails();
    fetchVacancyTypeData();
    fetchCityData();
    fetchAllCityLocations();
    fetchAllFranchiseWithLocations();
    fetchAllDepartments();
    fetchAllSkills();

    return () => {};
  }, []);

  if (!checkPermissionStatus("job-list", "edit")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-2 align-items-center py-2 ">
            <Col lg="8" md="6">
              <Link to="/Job-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" /> Edit Job
                </h5>
              </Link>
            </Col>

            {/* <Col lg="4" md="6">
              <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2 pt-2">
                <Link to="/Job-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section">
            <Row>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Job Title<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Title"
                  name="title"
                  value={statePayload?.title}
                  onChange={handleInput}
                />
                {errors?.title && (
                  <p className="text-danger mb-0 pb-1"> {errors?.title} </p>
                )}
              </Form.Group>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Position Level<span class="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="vacancy_type_id"
                  className="col-lg-4 col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleVtypeSelection(e.target?.value)}
                >
                  <option value="" selected>
                    Select Position Level
                  </option>
                  {vtypes &&
                    vtypes.map(el => {
                      return (
                        <option
                          key={el?.value}
                          value={el?.id}
                          selected={el?.id == statePayload?.vacancy_type_id}
                        >
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.vacancy_type_id && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.vacancy_type_id}{" "}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Mode Of Job<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    options={extendedOptions1}
                    value={extendedOptions1.find(
                      option => option?.value === statePayload?.mode_of_job
                    )}
                    onChange={handleSelectMode}
                  />{" "}
                </div>
                {errors?.mode_of_job && (
                  <p className="text-danger"> {errors?.mode_of_job} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Number Of Vacancies<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    options={extendedOptions2}
                    value={extendedOptions2.find(
                      option => option?.value === statePayload?.number_of_jobs
                    )}
                    onChange={handleNumberOfJobs}
                  />{" "}
                </div>
                {errors?.number_of_jobs && (
                  <p className="text-danger"> {errors?.number_of_jobs} </p>
                )}
              </Form.Group>

              {statePayload?.number_of_jobs === "Limited" && (
                <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                  <Form.Label className="float-label">
                    Number Of Openings<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Number Of Openings"
                    name="number_of_openings"
                    value={statePayload?.number_of_openings}
                    onChange={handleInput}
                  />
                  {errors?.number_of_openings && (
                    <p className="text-danger">
                      {" "}
                      {errors?.number_of_openings}{" "}
                    </p>
                  )}
                </Form.Group>
              )}

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Department<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    isMulti
                    options={extendedDeptOptions}
                    value={selectedDepts}
                    onChange={handleChangeDept}
                  />
                </div>
                {errors?.department_id && (
                  <p className="text-danger"> {errors?.department_id} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Qualification<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Required Qualification "
                  name="qualification"
                  value={statePayload?.qualification}
                  onChange={handleInput}
                />
                {errors?.qualification && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.qualification}{" "}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Experience<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Required Experience "
                  name="experience"
                  value={statePayload?.experience}
                  onChange={handleInput}
                />
                {errors?.experience && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.experience}{" "}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Expected Time<span class="text-danger">*</span>
                </Form.Label>
                <Select
                  options={expectedTimeOptions}
                  value={
                    expectedTimeOptions?.find(
                      el => el?.value === statePayload?.expected_time
                    ) || ""
                  }
                  onChange={e => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      expected_time: e?.value,
                    }));
                  }}
                />
                {errors?.expected_time && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.expected_time}{" "}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label required-skill-card">
                <Form.Label className="float-label">
                  Required Skills<span class="text-danger">*</span>
                </Form.Label>

                <CreatableSelect
                  placeholder={`Select skills required for the job`}
                  isClearable
                  isMulti
                  value={selectedSkills}
                  options={allSkills}
                  onChange={e => {
                    let selectedSkills = e?.map(skill => ({
                      ...skill,
                      value:
                        typeof skill?.value === "string"
                          ? skill?.value?.trim()
                          : skill?.value,
                      label: skill?.label?.trim(),
                    }));
                    setSelectedSkills(selectedSkills);
                  }}
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "auto", // Set the minimum height for better visibility
                      height: "auto", // Auto height depending on selected items
                      overflowY: "visible", // Ensure that overflow is visible
                      whiteSpace: "normal", // Allow wrapping of text
                    }),
                    valueContainer: base => ({
                      ...base,
                      maxHeight: "150px", // Set a max height for value container
                      overflowY: "auto", // Allow vertical scrolling if needed
                      whiteSpace: "normal", // Allow the text to wrap instead of being cut off
                    }),
                    multiValue: base => ({
                      ...base,
                      display: "flex",
                      flexWrap: "wrap", // Wrap the selected options
                      maxWidth: "100%", // Ensure it uses full width of the input box
                    }),
                    multiValueLabel: base => ({
                      ...base,
                      whiteSpace: "normal", // Wrap long skill names
                    }),
                  }}
                />

                {errors?.skills && (
                  <p className="text-danger mb-0 pb-1"> {errors?.skills} </p>
                )}
              </Form.Group>

              <Col md={12}>
                <Row>
                  <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                    <Form.Label className="float-label">
                      Job Mapping With
                    </Form.Label>

                    <Form.Check
                      type="radio"
                      id="option1"
                      name="location_mapped_with"
                      value="city"
                      label="City"
                      checked={["city"].includes(
                        statePayload?.location_mapped_with?.toLowerCase()
                      )}
                      onChange={e => {
                        setStatePayload(prev => ({
                          ...prev,
                          location_mapped_with: "city",
                        }));
                      }}
                    />

                    <Form.Check
                      type="radio"
                      id="option2"
                      name="location_mapped_with"
                      value="franchise"
                      label="Franchise"
                      checked={["franchise"].includes(
                        statePayload?.location_mapped_with?.toLowerCase()
                      )}
                      onChange={e => {
                        setStatePayload(prev => ({
                          ...prev,
                          location_mapped_with: "franchise",
                        }));
                      }}
                    />
                  </Form.Group>

                  {["franchise"].includes(
                    statePayload?.location_mapped_with?.toLowerCase()
                  ) ? (
                    <>
                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Franchise<span class="text-danger">*</span>
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            options={FranchiseList}
                            value={FranchiseList?.find(
                              f => f?.id === statePayload?.franchise_id
                            )}
                            onChange={e => {
                              let locationList = e?.locationList || [];
                              setAllFranchiseLocations(locationList);
                              setSelectedFranchiseLocations([]);

                              setStatePayload(prev => ({
                                ...prev,
                                franchise_id: e?.value,
                                franchise_location_id: [],
                              }));
                            }}
                          />
                        </div>
                        {errors?.franchise_id && (
                          <p className="text-danger">
                            {" "}
                            {errors?.franchise_id}{" "}
                          </p>
                        )}
                      </Form.Group>

                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Location
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            isMulti
                            options={extendedFranchiseLocationOptions}
                            value={selectedFranchiseLocations}
                            onChange={handleChangeFranchiseLocation}
                          />
                        </div>
                      </Form.Group>
                    </>
                  ) : (
                    <>
                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          City<span class="text-danger">*</span>
                        </Form.Label>
                        <Select
                          isMulti
                          options={extendedCityOptions}
                          value={selectedCities}
                          onChange={handleChangeCity}
                        />
                        {errors?.city_id && (
                          <p className="text-danger mb-0 pb-1">
                            {" "}
                            {errors?.city_id}{" "}
                          </p>
                        )}
                      </Form.Group>

                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Location
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            isMulti
                            options={extendedCityLocationOptions}
                            value={selectedCityLocations}
                            onChange={handleChangeCityLocation}
                            formatGroupLabel={data => (
                              <>
                                <div className="d-flex align-items-center justify-content-between">
                                  <span>{data?.label}</span>

                                  <span className="border rounded-circle text-center p-2 pt-1 pb-1 bg-secondary text-light">
                                    {data?.options?.length || 0}
                                  </span>
                                </div>
                              </>
                            )}
                          />
                        </div>
                      </Form.Group>
                    </>
                  )}
                </Row>
              </Col>

              <Form.Group className="col-md-12 mb-3 floating-label required-skill-card">
                <Form.Label className="float-label">
                  Job Description<span class="text-danger">*</span>
                </Form.Label>
                <ReactQuill
                  style={{ height: "200px" }}
                  placeholder="Job Description"
                  name="description"
                  value={statePayload?.description}
                  onChange={content => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      ["description"]: content,
                    }));
                  }}
                />
                {errors?.description && (
                  <p className="text-danger mt-5 mb-0 pb-1">
                    {" "}
                    {errors?.description}{" "}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-md-12 mb-3 floating-label mt-5 roundlist roundlist-post">
                <Form.Label className="float-label">
                  Round List<span class="text-danger">*</span>
                </Form.Label>
                <div className="d-flex flex-wrap gap-2 roundlist pt-1 mr-4 flex-column">
                  {roundList?.map((item, index) => (
                    <div
                      style={{ border: "1px solid lightgray", padding: "8px" }}
                      className="font-size-16 d-flex justify-content-between font-size"
                      key={item?.id}
                    >
                      <div>
                        {`${index + 1}. ${item?.label} [${item?.type}]`}{" "}
                        {item?.interviewer
                          ? `- ${item?.interviewer?.name} (${
                              item?.interviewer?.email
                            }) - ${
                              item?.meeting_type === 1 ? "Online" : "Offline"
                            }`
                          : `[Passing Threshold % - ${
                              item?.score_threshold || 0
                            }]`}
                      </div>
                    </div>
                  ))}
                </div>
                {roundList?.length === 0 && <div>No Rounds Available</div>}
                {errors?.roundList && (
                  <p className="text-danger mb-0 pb-1"> {errors?.roundList} </p>
                )}
              </Form.Group>

              <Form.Group className=" col-lg-6 col-md-12 mb-3 floating-label">
                <Form.Label className="float-label">
                  Budget Range<span class="text-danger">*</span>
                </Form.Label>
                <div className="d-flex gap-2 label-cardssrange">
                  <div className="w-100">
                    <div className="d-flex align-items-center budget-range">
                      <Form.Control
                        type="number"
                        placeholder="Enter Min. Budget"
                        name="min_salary"
                        value={statePayload?.min_salary}
                        onChange={handleInput}
                      />
                      <span className="font-size-16">
                        {companyCurrency?.symbol || ""}
                      </span>
                    </div>
                    {errors?.min_salary && (
                      <p className="text-danger mb-0 pb-1">
                        {" "}
                        {errors?.min_salary}{" "}
                      </p>
                    )}
                  </div>

                  <div className="w-100">
                    <div className="d-flex align-items-center  budget-range">
                      <Form.Control
                        type="number"
                        placeholder="Enter Max. Budget"
                        name="max_salary"
                        value={statePayload?.max_salary}
                        onChange={handleInput}
                      />
                      <span className="font-size-16">
                        {companyCurrency?.symbol || ""}
                      </span>
                    </div>
                    {errors?.max_salary && (
                      <p className="text-danger mb-0 pb-1">
                        {" "}
                        {errors?.max_salary}{" "}
                      </p>
                    )}
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="col-lg-3 col-md-6 mb-3 floating-label">
                <div className="flot-label-section">
                  <Form.Label className="float-label">
                    Min Relevancy Score %<span class="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Min Relevancy Score %"
                    name="relevance_score"
                    value={statePayload?.relevance_score}
                    onChange={handleInput}
                  />
                  {/* <div className="slider round"></div> */}
                </div>
                {errors?.relevance_score && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.relevance_score}{" "}
                  </p>
                )}
              </Form.Group>

              <div className="flot-label-section col-lg-3 col-md-6 mb-3 ">
                <Form.Label className="float-label">
                  Min Behavioural Score %<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Min Behavioural Score %"
                  name="video_analysis_score"
                  value={statePayload?.video_analysis_score}
                  onChange={handleInput}
                />
                {errors?.video_analysis_score && (
                  <p className="text-danger mb-0 pb-1">
                    {" "}
                    {errors?.video_analysis_score}{" "}
                  </p>
                )}
              </div>

              <Form.Group className="col-md-4 mb-3 floating-label licace-app-card">
                <div className="licace-app">
                  <Form.Label className="float-label">
                    Status<span class="text-danger">*</span>
                  </Form.Label>
                  <div className="mt-2">
                    <label className="switch" htmlFor={"tableSwitch"}>
                      <input
                        type="checkbox"
                        id={`tableSwitch`}
                        onClick={e => {
                          let value = e.target.checked ? "1" : "0";
                          handleInput({
                            target: { name: "status", value: value },
                          });
                        }}
                        checked={
                          statePayload?.status === "1"  
                        }
                      />
                      <div className="slider round"></div>
                    </label>
                  </div>
                  {errors?.status && (
                    <p className="text-danger"> {errors?.status} </p>
                  )}
                </div>
                <div className="licace-app">
                  <Form.Label className="float-label">
                    License Applicable<span class="text-danger">*</span>
                  </Form.Label>
                  <div className="mt-2">
                    <label className="switch" htmlFor={"licenseSwitch"}>
                      <input
                        type="checkbox"
                        id={`licenseSwitch`}
                        onClick={e => {
                          let value = e.target.checked ? "1" : "0";
                          handleInput({
                            target: { name: "license", value: value },
                          });
                        }}
                        checked={
                          statePayload?.job_specific_license === "1" ||
                          statePayload?.job_specific_license === 1
                        }
                      />
                      <div className="slider round"></div>
                    </label>
                  </div>

                  {/* <Form.Check
                type="checkbox"
                name="status"
                className="font-size-20 mx-2"
                checked={statePayload?.status === "1"}
                onChange={(e) => {
                  let value = e.target.checked ? "1" : "0"
                  handleInput({ target: { name: 'status', value: value } })
                }}
              /> */}

                  {errors?.license && (
                    <p className="text-danger"> {errors?.license} </p>
                  )}
                </div>
              </Form.Group>
              <Form.Group className="col-md-12 mb-3 floating-label  VideoAnalysisQuestion  mt-2">
                <Form.Label className="float-label">
                  Video Analysis Question<span class="text-danger">*</span>
                </Form.Label>

                <ReactQuill
                  className="comment-card"
                  style={{ height: "150px" }}
                  name="video_analysis_ques"
                  placeholder="Video Analysis Questions"
                  value={statePayload?.video_analysis_ques}
                  onChange={content => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      ["video_analysis_ques"]: content,
                    }));
                  }}
                />

                {errors?.video_analysis_ques && (
                  <p className="text-danger mt-5  mb-0 pb-1">
                    {" "}
                    {errors?.video_analysis_ques}{" "}
                  </p>
                )}
              </Form.Group>
            </Row>
            <Form.Group className="cta editjob-space edi text-center d-flex justify-content-start mt-4 gap-3">
              <Link to="/Job-list" className="btn btn-secondary">
                Cancel
              </Link>
              <ButtonLoader
                title="Update Details"
                variant="primary"
                type="submit"
                loading={isLoading}
                message={"Saving"}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EditJob;
